import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";

/**
 * Wiadomość, z informacją czy rezerwacja jest możliwa
 */
export class CheckBookingPossibleResult extends NfComponentGlobalMessage {
    declare public bookingPossible: boolean;
    declare public requestId: number;
    public constructor(sourceComponentId: number|MessageEvent<CheckBookingPossibleResult>, bookingPossible?: boolean, requestId?: number) {
        super(NfMessageType.CheckBookingPossibleResult, !NfMessage.isMessageEvent(sourceComponentId));
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
            if(typeof(bookingPossible) === 'undefined') {
                throw Error('bookingPossible jest wymagane');
            }
            this.bookingPossible = bookingPossible;
            if(!requestId) {
                throw Error('requestId jest wymagany');
            }
            this.requestId = requestId;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.CheckBookingPossibleResult] = (event) => {
    return new CheckBookingPossibleResult(event);
}
